export default __webpack_public_path__ + "static/media/resubmitted.22495771.svg";